/**
 * Service worker registration and the "new version" prompt. registerType is 'prompt' (see
 * vite.config.ts): a new version waits until the person taps Reload, so an update never lands
 * mid-shop.
 */
import { useEffect } from 'react'
import { registerSW } from 'virtual:pwa-register'
import { useToast } from '../ui'

export function UpdatePrompt() {
  const toast = useToast()

  useEffect(() => {
    // Registered here rather than at import time so a failed registration cannot stop the app
    // rendering: an app that will not open is worse than one that will not update.
    if (import.meta.env.DEV) return
    const update = registerSW({
      immediate: true,
      onNeedRefresh: () => {
        toast.show('A new version of Resupport is ready.', {
          duration: 0,
          action: { label: 'Reload', onClick: () => void update(true) },
        })
      },
      onOfflineReady: () => {
        toast.show('Ready to work offline.', { tone: 'success' })
      },
      onRegisterError: (err: unknown) => console.warn('[resupport] SW registration failed', err),
    })
  }, [toast])

  return null
}
